<template>
  <v-card>
    <v-card-title class="headline" primary-title>
      {{ $t('archive.add-file') }}
    </v-card-title>
    <v-container>
      <div>
        <v-select label="Team" v-model="teamIds" multiple item-text="name" item-value="id" :items="teams"></v-select>
        <v-text-field :label="`${$t('archive.choose_file')}`" @click="onPickFile" v-model='fileName' prepend-icon="attach_file"></v-text-field>
        <input type="file" style="display: none" ref="fileInput" accept="pdf" @change="onFilePicked">
        <v-btn :disabled="!this.isValid()" @click="upload()">{{$t('archive.upload')}}</v-btn>
        <v-progress-circular v-if="loading" color="primary" indeterminate></v-progress-circular>
      </div>
    </v-container>
  </v-card>
</template>

<script>
import http from '@/plugins/http'
export default {
  computed: {
    teams: {
      get: function(){ return this.$store.getters.teams }
    },
    locale: () => process.env.VUE_APP_LOCALE
  },
  data() {
    return {
      teamIds:[],
      fileName: "",
      file: undefined,
      show: false,
      operation: undefined,
      allowedOperations: [],
      loading: false
    }
  },
  methods: {
    upload() {
      if (!this.isValid()) {
        return
      }

      let formData = new FormData()
      formData.append('file', this.file)
      this.teamIds.forEach(id => formData.append('teamIds[]', id))

      this.loading = true
      http.post('user-file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(() => {
        this.show = false
        this.$store.commit("setSnack", {
          message: this.$t("upload.success"),
          color: "success",
        })
        this.$router.push('/user-files')
      }).catch(() => {
        this.$store.commit("setSnack", {
          message: this.$t("upload.server_error"),
          color: "danger",
        })
      }).finally(() => this.loading = false)

    },
    isValid() {
      return this.file != undefined && this.fileName != undefined && this.loading == false && this.teamIds.length > 0
    },
    onPickFile() {
      this.$refs.fileInput.click()
    },
    onFilePicked(event) {
      const files = event.target.files
      if (files[0] !== undefined) {

        if (files[0].name.lastIndexOf('.') <= 0) {
          return
        }
        this.fileName = files[0].name
        this.file = files[0]

      } else {
        this.fileName = undefined
        this.file = undefined
      }
    },
  },
  created() {
  }
}
</script>

<style>

</style>
